import React, {Component} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import CommunicationsLandingPage from "./CommunicationsLandingPage";
import PageNotFoundPage from "../common/errorPages/404";
import addTracking from '../../helpers/addTracking';
import InternalServerErrorPage from "../common/errorPages/500";
import AuthContainer from "../AuthContainer";
import SecureRoute from "../common/SecureRoute";
import NewCommunication from "./newCommunication/NewCommunication";
import VendorConcentrationMapContainer from "../vendorConcentration/VendorConcentrationMapContainer";
import CommunicationDetail from "./CommunicationDetail";

class CommunicationsContainer extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        addTracking();
    }

    render() {
        return (
            <div>
                <Switch>
                    <Route path="/redirect/:nonce" component={AuthContainer}/>
                    <Route exact path="/500" component={InternalServerErrorPage}/>
                    <Route exact path="/vendorconcentration" component={VendorConcentrationMapContainer}/>
                    <SecureRoute path="/communications/new/:currentStep?" component={NewCommunication}/>
                    <SecureRoute path="/communications/newFromEvent/:eventId?" component={NewCommunication}/>
                    <SecureRoute path="/communications/deleted" exact component={CommunicationsLandingPage}/>
                    <SecureRoute path="/communications/saved" exact component={CommunicationsLandingPage}/>
                    <SecureRoute path="/communications/sent" exact component={CommunicationsLandingPage}/>
                    <SecureRoute path="/communications/:id" exact component={CommunicationDetail}/>
                    <SecureRoute path="/communications" exact={false} component={CommunicationsLandingPage}/>
                    <Redirect from="/" to="communications"/>
                    <Route component={PageNotFoundPage}/>
                </Switch>
            </div>
        );
    }
}

export default CommunicationsContainer;

